import { render, staticRenderFns } from "./MainTopMenu.vue?vue&type=template&id=869d59f8&scoped=true&"
import script from "./MainTopMenu.vue?vue&type=script&lang=js&"
export * from "./MainTopMenu.vue?vue&type=script&lang=js&"
import style0 from "./MainTopMenu.vue?vue&type=style&index=0&id=869d59f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869d59f8",
  null
  
)

export default component.exports